module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABsSURBVEhL7c8xCsAwDENR07v1/kdyK5SooyHy0MEfQrL44URHmXmvpx+w9yAfBUJLnaMYpqEGK8IwDTVYEYZpqMGKMExD/QO71t0ftuJy6vzLOyC01KBmQGipQc2A0FKDmgGhpVpRH9t9WMQDdDUzPdOZXQ0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/white-left-carot-large.png
// module id = 1402
// module chunks = 0